import GeneralProduct from '~/Api/Product/Product';

export class Product {
	packageSizeForCalculation: number | null;

	product: GeneralProduct;

	constructor(packageSizeForCalculation: number | null, product: GeneralProduct) {
		this.packageSizeForCalculation = packageSizeForCalculation;
		this.product = product;
	}
}
